"use client";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../core/factory/factory.mjs";
import { ModalBaseHeader } from "../ModalBase/ModalBaseHeader.mjs";
import { useModalContext } from "./Modal.context.mjs";
import Modal_module_default from "./Modal.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Modal/ModalHeader.tsx
const ModalHeader = factory((_props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("ModalHeader", null, _props);
	return /* @__PURE__ */ jsx(ModalBaseHeader, {
		...useModalContext().getStyles("header", {
			classNames,
			style,
			styles,
			className
		}),
		...others
	});
});
ModalHeader.classes = Modal_module_default;
ModalHeader.displayName = "@mantine/core/ModalHeader";
//#endregion
export { ModalHeader };

//# sourceMappingURL=ModalHeader.mjs.map